import React, { useState, useEffect } from 'react';
import { DateRange } from 'react-date-range';
import { format, addDays } from 'date-fns';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { es } from 'date-fns/locale';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import styles from './DatePickerRange.module.scss';

interface DatePickerRangeProps {
  initialStartDate?: Date | null;
  initialEndDate?: Date | null;
  minDate?: Date;
  maxDate?: Date;
  onChange?: (range: { startDate: Date; endDate: Date }) => void;
}

const DatePickerRange: React.FC<DatePickerRangeProps> = ({
  initialStartDate = null,
  initialEndDate = null,
  minDate,
  maxDate,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRange, setSelectedRange] = useState([
    {
      startDate: initialStartDate,
      endDate: initialEndDate,
      key: 'selection',
    },
  ]);

  useEffect(() => {
    setSelectedRange([
      {
        startDate: initialStartDate,
        endDate: initialEndDate,
        key: 'selection',
      },
    ]);
  }, [initialStartDate, initialEndDate]);

  const formattedDate = selectedRange[0].startDate && selectedRange[0].endDate
    ? `${format(selectedRange[0].startDate, 'dd/MM/yyyy')} - ${format(selectedRange[0].endDate, 'dd/MM/yyyy')}`
    : '';

  const handleSelect = (ranges: any) => {
    setSelectedRange([ranges.selection]);
    if (onChange) {
      onChange({
        startDate: ranges.selection.startDate,
        endDate: ranges.selection.endDate,
      });
    }
  };

  const toggleCalendar = () => {
    setIsOpen(!isOpen);
  };

  const handleClickAway = () => {
    setIsOpen(false);
  };

  return (
    <div className="input-group">
      <span className="input-group-text" onClick={toggleCalendar}>
        <i className="iconwhite-calendario6"></i>
      </span>
      <div className={styles.datePickerContainer}>
        <input
          type="text"
          className={`form-control ${styles['datePickerContainer-input']}`}
          readOnly
          value={formattedDate}
          onClick={toggleCalendar}
          placeholder="Seleccione un rango de fechas"
        />
        {isOpen && (
          <ClickAwayListener onClickAway={handleClickAway}>
            <div style={{ position: 'absolute', zIndex: 1000 }}>
              <DateRange
                editableDateInputs={true}
                onChange={handleSelect}
                moveRangeOnFirstSelection={false}
                ranges={selectedRange}
                minDate={minDate}
                maxDate={maxDate}
                locale={es}
              />
            </div>
          </ClickAwayListener>
        )}
      </div>
    </div>
  );
};

export default DatePickerRange;
